export const APPLICATION_TRANSITION_MESSAGE = "This candidate was updated. We refreshed their status.";

export const APPLICATION_TRANSITION_DROPPED_MESSAGE = "This candidate was already updated somewhere else, so your action was not applied.";

export const APPLICATION_TRANSITION_CONFIRM_MESSAGE = "This candidate was updated while you were reviewing them. We put them back in your queue so you can confirm.";

export const APPLICATION_TRANSITION_SOURCES = Object.freeze({
  APPLICATION: "application",
  DRAFT_DOUBLE: "draft-double",
  DRAFT_SINGLE: "draft-single",
  GUIDED_TOUR: "guided-tour",
  INTERVIEW: "interview",
  KANBAN: "kanban",
  UNDO: "undo",
});

const APPLICATION_TRANSITION_CONFLICT_CODES = new Set([
  "application_transition_conflict",
  "application_transition_refresh_required",
  "application_transition_action_mismatch",
]);

export const isApplicationTransitionConflict = (error) => {
  const response = error?.response || error;

  return response?.status === 409
    && APPLICATION_TRANSITION_CONFLICT_CODES.has(response?.data?.code);
};

export const shouldSuppressGlobalAxiosToast = isApplicationTransitionConflict;
